
import { Component, Input } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';

export type PlaceholderSet = 'basic' | 'full';

interface PlaceholderRow {
  key: string;
  description: string;
}

const BASIC_PLACEHOLDERS: PlaceholderRow[] = [
  { key: '___BOTID', description: $localize`:@@html-placeholder-botid:Die Bot-ID` },
  { key: '___BOTSRC', description: $localize`:@@html-placeholder-botscr:Die Bot-URL (z. B. für den Bot iFrame)` },
  { key: '___BOTNAME', description: $localize`:@@html-placeholder-botname:Der Bot-name` },
  { key: '___BOTLANG', description: $localize`:@@html-placeholder-botlang:Die Bot-Sprache (z. B. "de", "en", "fr", "es" usw.)` },
  { key: '___FUSIONID', description: $localize`:@@html-placeholder-fusionid:Die Fusion-ID` },
  { key: '___BOTHIDDEN', description: $localize`:@@html-placeholder-bothidden:Bot ausblenden (true/false)` },
  { key: '___BOTBUTTONHIDDEN', description: $localize`:@@html-placeholder-botbuttonhidden:Bot-Button ausblenden (true/false)` },
  { key: '___VIEWMODE', description: $localize`:@@html-placeholder-viewmode:Ansichtsmodus (split, window, full, float)` }
];

const EXTRA_PLACEHOLDERS: PlaceholderRow[] = [
  { key: '___CUSTOMJS', description: $localize`:@@html-placeholder-customjs:Das Custom JavaScript aus dem Logik-Editor` }
];

@Component({
  selector: 'app-placeholder-overlay',
  standalone: true,
  imports: [DialogModule, TableModule],
  template: `
    <p-dialog
      [(visible)]="visible"
      [modal]="true"
      [draggable]="false"
      i18n-header="@@placeholder"
      header="Platzhalter"
      [style]="{ width: '600px' }"
    >
      <p-table [value]="rows" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th i18n="@@placeholder">Platzhalter</th>
            <th i18n="@@description">Beschreibung</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td><code>{{ row.key }}</code></td>
            <td>{{ row.description }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-dialog>
  `
})
export class PlaceholderOverlayComponent {
  public visible = false;

  private _set: PlaceholderSet = 'basic';

  @Input() public set set(value: PlaceholderSet) {
    this._set = value;
    this.rows = value === 'full'
      ? [...BASIC_PLACEHOLDERS, ...EXTRA_PLACEHOLDERS]
      : [...BASIC_PLACEHOLDERS];
  }

  public rows: PlaceholderRow[] = [...BASIC_PLACEHOLDERS];
}
